import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import * as XLSX from "xlsx";

const HybridUps = () => {
  const stateName = sessionStorage.getItem("selectedState");
  const siteId = sessionStorage.getItem("selectedSiteId");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedFields, setSelectedFields] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [fieldOptions, setFieldOptions] = useState([]);
  const breadcrumbs = [
    <Link key="1" sx={{ color: "black" }} href="/dashboard">
      Dashboard
    </Link>,
    <Link key="2" sx={{ color: "black" }} href={`/dashboard`}>
      {stateName}
    </Link>,
    <Link key="3" sx={{ color: "black" }} href={`/${stateName}/displaySite`}>
      Display Sites
    </Link>,
    <Link key="4" sx={{ color: "black" }} href={`/historical_data`}>
      Historical Data
    </Link>,
    <Typography key="5" sx={{ color: "text.primary" }}>
      Hybrid UPS
    </Typography>,
  ];

  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(
        "https://api.bharatnet.sunshineiotronics.com/api/v2/hups/historical",
        {
          site_id: siteId,
          page: currentPage,
          limit: rowsPerPage,
        }
      );
      setData(response.data);

      // ✅ Extract field options from flat object structure
      const allFields = Object.keys(response.data[0] || {}).filter(
        (key) => key !== "site_id" && key !== "controller_datetime"
      );
      setFieldOptions(allFields);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [currentPage, siteId]);

  console.log(currentPage);

  const formatHeader = (header) => {
    return header
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const selectedVariables = [

      "total_system_capacity",
      "rectifier_output_current",
      "battery_capacity",
   
"rm_replaced", "ac_mains_run_hours", "battery_run_hours",

      "mppt_1_output_current",
      "mppt_1_output_voltage",
      "mppt_1_output_power",


      "battery_lvd_set",
      "battery_low_alarm_voltage_set",
      "rectifier_unit_overload",

"battery_current_1", "voltage_module_1", "soc_module_1",

      "inv_dc_input_voltage",
      "inv_bypass_ac_input_voltage",
      "inv_output_voltage",

  ]

 const combinedData = data.map((item) => {
  const result = {
    controller_datetime: item.controller_datetime,
    site_id: item.site_id,
  };
  selectedFields.forEach((field) => {
    result[field] = item[field];
  });
  return result;
});

  const handleFieldChange = (event) => {
    setSelectedFields(event.target.value);
  };

  const handleDownload = async () => {
    if (!fromDate || !toDate || selectedFields.length === 0) {
      alert("Please fill all the fields and select at least one parameter.");
      return;
    }

    const formatDate = (date) => {
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const formattedFromDate = formatDate(fromDate);
    const formattedToDate = formatDate(toDate);

    const payload = {
      site_id: siteId,
      parameters: selectedFields,
      from_date: formattedFromDate,
      to_date: formattedToDate,
    };
    console.log(payload);

    try {
      setLoading(true);
      const response = await axios.post(
        "https://api.bharatnet.sunshineiotronics.com/api/v2/hups/filter",
        payload
      );

      // Prepare the data for Excel
      const excelData = response.data.map((item) => {
        const formattedItem = {
          site_id: item.site_id,
          controller_datetime: item.controller_datetime,
        };

        selectedFields.forEach((field) => {
          formattedItem[field] = item[field];
        });

        return formattedItem;
      });

      // Create Excel sheet
      const ws = XLSX.utils.json_to_sheet(excelData);

      // Create a new workbook and add the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Historical Data");

      // Download the Excel file
      XLSX.writeFile(
        wb,
        `HistoricalData_${formattedFromDate}_to_${formattedToDate}.xlsx`
      );
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Failed to download the file. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const renderTable = (tableData) => (
    <Table size="small" sx={{ marginBottom: "2rem" }}>
      <TableHead
        sx={{
          padding: "8px",
          whiteSpace: "normal",
          textAlign: "center",
          backgroundColor: "rgb(250,223,186)",
        }}
      >
        <TableRow>
          {tableData.length > 0 &&
            Object.keys(tableData[0]).map((key) => (
              <TableCell
                key={key}
                sx={{
                  textAlign: "center",
                  border: "1px solid #997d3d",
                  fontSize: "15px",
                }}
              >
                {formatHeader(key)}
              </TableCell>
            ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {tableData.length > 0 &&
          tableData.map((row, index) => (
            <TableRow key={index}>
              {Object.values(row).map((value, idx) => (
                <TableCell
                  key={idx}
                  sx={{
                    textAlign: "center",
                    border: "1px solid #997d3d",
                    fontSize: "13px",
                  }}
                >
                  {value}
                </TableCell>
              ))}
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );

  return (
    <Box m="1.5rem 2.5rem">
      <Stack spacing={2}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="medium" />}
          aria-label="breadcrumb"
        >
          {breadcrumbs}
        </Breadcrumbs>
      </Stack>
      <br />

      {/* Form Section */}
      {/* Form Section */}
      <Box
        component="form"
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "normal",
          gap: 2,
          padding: 2,
          border: "1px solid #ccc",
          borderRadius: 2,
          marginTop: 2,
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <TextField
          label="From Date"
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          sx={{ flex: "1" }}
        />
        <TextField
          label="To Date"
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          sx={{ flex: "1" }}
        />
        <FormControl sx={{ minWidth: 200, flex: "2" }}>
          <InputLabel>Select Parameters</InputLabel>
          <Select
            multiple
            value={selectedFields}
            onChange={handleFieldChange}
            input={<OutlinedInput label="Select Parameters" />}
            renderValue={(selected) => selected.map(formatHeader).join(", ")}
            MenuProps={{
              PaperProps: {
                style: {
                  width: 200,
                },
              },
            }}
          >
            {fieldOptions.map((field) => (
              <MenuItem key={field} value={field}>
                <Checkbox checked={selectedFields.includes(field)} />
                <ListItemText primary={formatHeader(field)} />
              </MenuItem>
            ))}
            {/* OK Button */}
            <MenuItem
              disableRipple
              sx={{
                display: "flex",
                justifyContent: "center",
                paddingTop: 1,
                paddingBottom: 1,
                borderTop: "1px solid #ddd",
              }}
            >
              <Button
                variant="contained"
                size="small"
                onClick={() => {
                  console.log("Selected Fields:", selectedFields);
                  document.activeElement.blur();
                }}
              >
                OK
              </Button>
            </MenuItem>
          </Select>
        </FormControl>

        <Button
          variant="outlined"
          color="secondary"
          sx={{ height: "56px" }}
          onClick={handleDownload}
        >
          Download
        </Button>
      </Box>
      <br />

      {loading ? (
        <Typography>Loading...</Typography>
      ) : error ? (
        <Typography color="error">Error: {error}</Typography>
      ) : combinedData.length === 0 ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="60vh"
          sx={{
            textAlign: "center",
            borderRadius: "8px",
            p: 3,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "#997d3d",
              marginBottom: "8px",
            }}
          >
            No Data Available
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#7c7c7c",
              maxWidth: "400px",
            }}
          >
            We couldn't find any data to display. Please try again later or
            check your Site ID.
          </Typography>
        </Box>
      ) : (
        <Box>
          <Typography variant="h4">{siteId}</Typography>
          <br />
          {renderTable(combinedData)}
        </Box>
      )}

      <Box mt={3} display="flex" justifyContent="start">
        {data.length > 0 && (
          <Stack direction="row" spacing={2}>
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              style={{
                width: "10rem",
                height: "3rem",
                fontSize: "15px",
                padding: "8px 16px",
                backgroundColor: currentPage === 1 ? "#ddd" : "#997d3d",
                color: currentPage === 1 ? "#aaa" : "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              Previous
            </button>
            <button
              disabled={data.length < rowsPerPage}
              onClick={() => setCurrentPage((prev) => prev + 1)}
              style={{
                width: "10rem",
                height: "3rem",
                fontSize: "15px",
                padding: "8px 16px",
                backgroundColor: data.length < rowsPerPage ? "#ddd" : "#997d3d",
                color: data.length < rowsPerPage ? "#aaa" : "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: data.length < rowsPerPage ? "not-allowed" : "pointer",
              }}
            >
              Next
            </button>
          </Stack>
        )}
      </Box>

      <br />
    </Box>
  );
};

export default HybridUps;
